export default __webpack_public_path__ + "static/universltpro-bold-50c89c83fb1280ca78bfd690c3c14cb2.woff2";